export {
  financialApiSlice,
  useGetFinancialRestrictionsQuery,
} from "./financial";
